import React from 'react';
import { PopupWrapper } from '../../resources/styling/appStyle';

const ImagePopup = ({ onClose, open, children }) => {
  return <PopupWrapper>{children}</PopupWrapper>;
};

export default ImagePopup;
